import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { registerServiceWorker } from './registerServiceWorker';
import './styles/index.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// After the render call, not before: the worker is for the *next* visit, and
// the first one should spend its bandwidth on the screen in front of the user.
registerServiceWorker();
